// extracted by mini-css-extract-plugin
export default {"button":"Yo-z","reviewSort":"Zo-z"};